import "core-js/modules/es.json.stringify.js";
import axios from 'axios'; // 引入axios
import { Message } from 'element-ui';
import { store } from '@/store/index';
import context from '@/main.js';
import { Loading } from 'element-ui';
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 99999
});
var acitveAxios = 0;
var timer;
var showLoading = function showLoading() {
  acitveAxios++;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(function () {
    if (acitveAxios > 0) {
      context.$bus.emit("showLoading");
    }
  }, 400);

  //这里是全部的接口请求加loading
  var loadingk = Loading.service({
    lock: true,
    text: '努力加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.3)',
    target: document.querySelector('#targetID') // 设置加载动画区域
  });

  setTimeout(function () {
    loadingk.close();
  }, 500);
};
var closeLoading = function closeLoading() {
  acitveAxios--;
  if (acitveAxios <= 0) {
    clearTimeout(timer);
    context.$bus.emit("closeLoading");
  }
};
//http request 拦截器
service.interceptors.request.use(function (config) {
  if (!config.donNotShowLoading) {
    showLoading();
  }
  var token = store.getters['user/token'];
  var user = store.getters['user/userInfo'];
  config.data = JSON.stringify(config.data);
  config.headers = {
    'Content-Type': 'application/json',
    'Authorization': "Bearer " + token,
    'x-user-id': user.ID
  };
  return config;
}, function (error) {
  closeLoading();
  Message({
    showClose: true,
    message: error,
    type: 'error'
  });
  return error;
});

//http response 拦截器
service.interceptors.response.use(function (response) {
  closeLoading();
  if (response.headers["new-token"]) {
    store.commit('user/setToken', response.headers["new-token"]);
  }
  if (response.data.code == 0 || response.headers.success === "true") {
    return response.data;
  } else {
    Message({
      showClose: true,
      message: response.data.err || response.data.msg || decodeURI(response.headers.err) || decodeURI(response.headers.msg),
      type: response.headers.msgtype || 'error'
    });
    if (response.data.data && response.data.data.reload) {
      setTimeout(function () {
        store.commit('user/LoginOut');
      }, 1000);
    }
    return response.data ? response.data : response;
  }
}, function (error) {
  closeLoading();
  Message({
    showClose: true,
    message: error,
    type: 'error'
  });
  return error;
});
export default service;